{{#if hasMonitor}}
virtual function bit has_monitor();
  return {{ interfaceBoundVariable.identifier }};
endfunction
{{/if}}
